// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.3_webpack@5.99.6/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/select.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.3_webpack@5.99.6/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/multi-select.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.3_webpack@5.99.6/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/toast.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.3_webpack@5.99.6/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/toggle-actions.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.3_webpack@5.99.6/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/table.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.3_webpack@5.99.6/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/tab-view.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Inter-Semi-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Inter;
  font-weight: 300 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}

@font-face {
  font-family: Inter;
  font-weight: 500 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}

@font-face {
  font-family: Inter;
  font-weight: 700 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}

@font-face {
  font-family: Inter;
  font-weight: 1000;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}

html,
body,
#root,
#root > div {
  height: 100%;
  margin: 0;
  box-sizing: border-box;
  overflow: auto;
}

:root {
  --primary-background-color: #fafafa;
  --secondary-background-color: #377771;
  --tertiary-background-color: #c9d9d8;
  --light-background-color: #f2f2f2;
  --primary-text-color: #222222;
  --secondary-text-color: #b8b8b5;
  --secondary-accent-text-color: #636360;
  --tertiary-text-color: #377771;
  --tertiary-accent-text-color: #9bbbb8;
  --white-text-color: #ffffff;
  --error-text-color: #cf4848;
  --primary-border-color: #d9d9d9;
  --secondary-border-color: #dcdcd9;
  --primary-button-color: #000000;
  --highlight-blue-color: #004db2;
  --disabled-button-color: #1d1d1b;
  --start-background-color: #c4d8ff;
  --start-actions-color: #2b72ff;
  --light-blue-background-color: #edf2fe;
  --green-background-color: #d1ffc4;
  --light-green-color: #e7ede8;
  --overlay-opacity: 0;
  --hover-opacity: 0.8;
  --pressed-opacity: 0.7;
  --disabled-opacity: 0.45;
  --hover-primary-color: #ededed;
  --shadow-high: 0 6px 3px 0 rgba(29, 29, 27, 0.06);
  --shadow-low: 0 3px 3px 0 rgba(16, 16, 15, 0.04);
  --shadow-navigation: 0 -6px 3px 0 rgba(29, 29, 27, 0.06);
}

body,
input,
textarea,
button {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body,
#root {
  background-color: var(--primary-background-color);
  color: var(--primary-text-color);
  font-size: 14px;
}

button,
input,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
}

.title-1 {
  color: var(--primary-text-color);
  font-size: 24px;
  font-weight: 1000;
}

.title-1-variant {
  color: var(--primary-text-color);
  font-size: 24px;
  font-weight: 800;
}

.title-1-variant-low {
  color: var(--primary-text-color);
  font-size: 18px;
  font-weight: 800;
}

.title-2 {
  color: var(--white-text-color);
  font-size: 16px;
  font-weight: 500;
}

.title-2-variant {
  color: var(--primary-text-color);
  font-size: 16px;
  font-weight: 800;
}

.title-2-variant-low {
  color: var(--secondary-accent-text-color);
  font-size: 16px;
  font-weight: 400;
}

.title-3 {
  color: var(--primary-text-color);
  font-size: 14px;
  font-weight: 800;
}

.title-3-variant {
  color: var(--primary-text-color);
  font-size: 14px;
  font-weight: 400;
}

.title-3-variant-low {
  color: var(--primary-text-color);
  font-size: 14px;
  font-weight: 600;
}

.title-4 {
  color: var(--primary-text-color);
  font-size: 12px;
  font-weight: 500;
}

.subtitle-1 {
  color: var(--tertiary-accent-text-color);
  font-size: 14px;
  font-weight: 400;
}

.subtitle-1-variant {
  color: var(--secondary-accent-text-color);
  font-size: 14px;
  font-weight: 400;
}

.subtitle-2 {
  color: var(--secondary-accent-text-color);
  font-size: 12px;
  font-weight: 400;
}

.subtitle-2-variant {
  color: var(--secondary-accent-text-color);
  font-size: 12px;
  font-weight: 600;
}

.subtitle-2-variant-low {
  color: var(--white-text-color);
  font-size: 12px;
  font-weight: 600;
}

.subtitle-3 {
  color: var(--secondary-accent-text-color);
  font-size: 12px;
  font-weight: 600;
}

.subtitle-4 {
  color: var(--secondary-accent-text-color);
  font-size: 18px;
  font-weight: 500;
}

.link-1 {
  color: var(--primary-text-color);
  font-size: 14px;
  font-weight: 400;
  text-underline-offset: 5px;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  height: min-content;
}

.mb-48 {
  margin-bottom: 48px;
}

.mb-32 {
  margin-bottom: 32px;
}

.mb-24 {
  margin-bottom: 24px;
}

.mb-18 {
  margin-bottom: 18px;
}

.mb-12 {
  margin-bottom: 12px;
}

.form-group {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: min-content 1fr;
  justify-content: space-between;
  gap: 8px;
}

label {
  font-weight: 500;
  font-size: 14px;
}

.label-2 {
  font-weight: 400;
  color: var(--secondary-accent-text-color);
}

.titlecase {
  text-transform: lowercase; /* Ensure all text is lowercase */
}

.titlecase::first-letter {
  text-transform: uppercase; /* Capitalize the first letter */
}

input[type="email"],
input[type="password"],
input[type="text"],
input[type="tel"] {
  width: 100%;
  padding: 12px;
  font-size: 14px;
  border: 1px solid var(--primary-border-color);
  border-radius: 5px;
  box-sizing: border-box;
  height: 40px;
  text-overflow: ellipsis;

  &::placeholder {
    color: var(--secondary-text-color);
  }

  &.grey-input {
    border: none;
    background-color: var(--primary-background-color);
  }

  &.error {
    border: 1px solid var(--error-text-color);
  }
}

input[type="checkbox"] {
  cursor: pointer;

  & + label {
    cursor: pointer;
  }
}

.btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  font-weight: 400;
  line-height: 24px;
  border: none;
  color: var(--fg-color);
  appearance: none;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 4px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:hover {
    opacity: var(--hover-opacity);
  }

  &:active {
    opacity: var(--pressed-opacity);
  }
}

.btn--primary {
  background-color: var(--primary-text-color);
  color: var(--white-text-color);

  &[disabled],
  &[aria-disabled="true"] {
    cursor: not-allowed;
    background-color: var(--secondary-accent-text-color);
  }
}

.btn--icon-only {
  padding: 10px;
}

.btn--secondary {
  background-color: var(--light-background-color);
  color: var(--secondary-accent-text-color);
}

.btn--icon-label {
  & p {
    padding-left: 8px;
  }
}

.btn--transparent {
  background-color: transparent;

  &:hover {
    background-color: var(--light-background-color);
  }
}

.checkbox-container {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: var(--secondary-accent-text-color);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.checkmark {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-right: 8px;
  border: 1px solid var(--primary-border-color);
  border-radius: 2px;
  position: relative;
  background-color: var(--white-text-color);
}

.cursor {
  cursor: pointer;
}

.company-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon {
  color: var(--white-text-color);
  stroke-width: 1.5px;
}

.icon-success {
  fill: var(--secondary-background-color);
}

.icon-danger {
  fill: var(--error-text-color);
}

.icon-information {
  fill: var(--highlight-blue-color);
}

.icon-secondary {
  color: var(--secondary-accent-text-color);
}

.icon-navigation {
  color: var(--primary-text-color);
  fill: var(--white-text-color);
}

.icon-navigation-active {
  fill: var(--primary-text-color);
  color: var(--white-text-color);
}

.icon-desktop-navigation-active {
  fill: var(--tertiary-text-color);
  color: var(--white-text-color);
}

.icon-success-toast {
  fill: var(--secondary-background-color);
  color: var(--primary-text-color);
}

.icon-danger-toast {
  fill: var(--error-text-color);
  color: var(--primary-text-color);
}

.required:after {
  content: " *";
  color: var(--error-text-color);
}

.error-message {
  color: var(--error-text-color);
  font-size: 12px;
  font-weight: 400;
}

#webpack-dev-server-client-overlay {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAOA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4CAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4CAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4CAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4CAAgC;EAChC,kBAAkB;AACpB;;AAEA;;;;EAIE,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,+BAA+B;EAC/B,sCAAsC;EACtC,8BAA8B;EAC9B,qCAAqC;EACrC,2BAA2B;EAC3B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,8BAA8B;EAC9B,sCAAsC;EACtC,iCAAiC;EACjC,4BAA4B;EAC5B,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,iDAAiD;EACjD,gDAAgD;EAChD,wDAAwD;AAC1D;;AAEA;;;;EAIE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,iDAAiD;EACjD,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;;EAIE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;;;;;EAOE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mCAAmC;EACnC,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA;;;;EAIE,WAAW;EACX,aAAa;EACb,eAAe;EACf,6CAA6C;EAC7C,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;;EAEvB;IACE,kCAAkC;EACpC;;EAEA;IACE,YAAY;IACZ,iDAAiD;EACnD;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,eAAe;;EAEf;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB;gEAC8D;;EAE9D;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;;EAE9B;;IAEE,mBAAmB;IACnB,oDAAoD;EACtD;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+CAA+C;EAC/C,yCAAyC;AAC3C;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,6BAA6B;;EAE7B;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["@import url(\"./styles/select.css\");\n@import url(\"./styles/multi-select.css\");\n@import url(\"./styles/toast.css\");\n@import url(\"./styles/toggle-actions.css\");\n@import url(\"./styles/table.css\");\n@import url(\"./styles/tab-view.css\");\n\n@font-face {\n  font-family: Inter;\n  font-weight: 300 400;\n  src: url(\"fonts/Inter-Regular.ttf\");\n  font-display: swap;\n}\n\n@font-face {\n  font-family: Inter;\n  font-weight: 500 600;\n  src: url(\"fonts/Inter-Medium.ttf\");\n  font-display: swap;\n}\n\n@font-face {\n  font-family: Inter;\n  font-weight: 700 900;\n  src: url(\"fonts/Inter-Semi-Bold.ttf\");\n  font-display: swap;\n}\n\n@font-face {\n  font-family: Inter;\n  font-weight: 1000;\n  src: url(\"fonts/Inter-Bold.ttf\");\n  font-display: swap;\n}\n\nhtml,\nbody,\n#root,\n#root > div {\n  height: 100%;\n  margin: 0;\n  box-sizing: border-box;\n  overflow: auto;\n}\n\n:root {\n  --primary-background-color: #fafafa;\n  --secondary-background-color: #377771;\n  --tertiary-background-color: #c9d9d8;\n  --light-background-color: #f2f2f2;\n  --primary-text-color: #222222;\n  --secondary-text-color: #b8b8b5;\n  --secondary-accent-text-color: #636360;\n  --tertiary-text-color: #377771;\n  --tertiary-accent-text-color: #9bbbb8;\n  --white-text-color: #ffffff;\n  --error-text-color: #cf4848;\n  --primary-border-color: #d9d9d9;\n  --secondary-border-color: #dcdcd9;\n  --primary-button-color: #000000;\n  --highlight-blue-color: #004db2;\n  --disabled-button-color: #1d1d1b;\n  --start-background-color: #c4d8ff;\n  --start-actions-color: #2b72ff;\n  --light-blue-background-color: #edf2fe;\n  --green-background-color: #d1ffc4;\n  --light-green-color: #e7ede8;\n  --overlay-opacity: 0;\n  --hover-opacity: 0.8;\n  --pressed-opacity: 0.7;\n  --disabled-opacity: 0.45;\n  --hover-primary-color: #ededed;\n  --shadow-high: 0 6px 3px 0 rgba(29, 29, 27, 0.06);\n  --shadow-low: 0 3px 3px 0 rgba(16, 16, 15, 0.04);\n  --shadow-navigation: 0 -6px 3px 0 rgba(29, 29, 27, 0.06);\n}\n\nbody,\ninput,\ntextarea,\nbutton {\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\",\n    \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody,\n#root {\n  background-color: var(--primary-background-color);\n  color: var(--primary-text-color);\n  font-size: 14px;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: 100%;\n}\n\n.title-1 {\n  color: var(--primary-text-color);\n  font-size: 24px;\n  font-weight: 1000;\n}\n\n.title-1-variant {\n  color: var(--primary-text-color);\n  font-size: 24px;\n  font-weight: 800;\n}\n\n.title-1-variant-low {\n  color: var(--primary-text-color);\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.title-2 {\n  color: var(--white-text-color);\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.title-2-variant {\n  color: var(--primary-text-color);\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.title-2-variant-low {\n  color: var(--secondary-accent-text-color);\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.title-3 {\n  color: var(--primary-text-color);\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.title-3-variant {\n  color: var(--primary-text-color);\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.title-3-variant-low {\n  color: var(--primary-text-color);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.title-4 {\n  color: var(--primary-text-color);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.subtitle-1 {\n  color: var(--tertiary-accent-text-color);\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.subtitle-1-variant {\n  color: var(--secondary-accent-text-color);\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.subtitle-2 {\n  color: var(--secondary-accent-text-color);\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.subtitle-2-variant {\n  color: var(--secondary-accent-text-color);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.subtitle-2-variant-low {\n  color: var(--white-text-color);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.subtitle-3 {\n  color: var(--secondary-accent-text-color);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.subtitle-4 {\n  color: var(--secondary-accent-text-color);\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.link-1 {\n  color: var(--primary-text-color);\n  font-size: 14px;\n  font-weight: 400;\n  text-underline-offset: 5px;\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  height: min-content;\n}\n\n.mb-48 {\n  margin-bottom: 48px;\n}\n\n.mb-32 {\n  margin-bottom: 32px;\n}\n\n.mb-24 {\n  margin-bottom: 24px;\n}\n\n.mb-18 {\n  margin-bottom: 18px;\n}\n\n.mb-12 {\n  margin-bottom: 12px;\n}\n\n.form-group {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: min-content 1fr;\n  justify-content: space-between;\n  gap: 8px;\n}\n\nlabel {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.label-2 {\n  font-weight: 400;\n  color: var(--secondary-accent-text-color);\n}\n\n.titlecase {\n  text-transform: lowercase; /* Ensure all text is lowercase */\n}\n\n.titlecase::first-letter {\n  text-transform: uppercase; /* Capitalize the first letter */\n}\n\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"text\"],\ninput[type=\"tel\"] {\n  width: 100%;\n  padding: 12px;\n  font-size: 14px;\n  border: 1px solid var(--primary-border-color);\n  border-radius: 5px;\n  box-sizing: border-box;\n  height: 40px;\n  text-overflow: ellipsis;\n\n  &::placeholder {\n    color: var(--secondary-text-color);\n  }\n\n  &.grey-input {\n    border: none;\n    background-color: var(--primary-background-color);\n  }\n\n  &.error {\n    border: 1px solid var(--error-text-color);\n  }\n}\n\ninput[type=\"checkbox\"] {\n  cursor: pointer;\n\n  & + label {\n    cursor: pointer;\n  }\n}\n\n.btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  font-weight: 400;\n  line-height: 24px;\n  border: none;\n  color: var(--fg-color);\n  appearance: none;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 4px;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n  &:hover {\n    opacity: var(--hover-opacity);\n  }\n\n  &:active {\n    opacity: var(--pressed-opacity);\n  }\n}\n\n.btn--primary {\n  background-color: var(--primary-text-color);\n  color: var(--white-text-color);\n\n  &[disabled],\n  &[aria-disabled=\"true\"] {\n    cursor: not-allowed;\n    background-color: var(--secondary-accent-text-color);\n  }\n}\n\n.btn--icon-only {\n  padding: 10px;\n}\n\n.btn--secondary {\n  background-color: var(--light-background-color);\n  color: var(--secondary-accent-text-color);\n}\n\n.btn--icon-label {\n  & p {\n    padding-left: 8px;\n  }\n}\n\n.btn--transparent {\n  background-color: transparent;\n\n  &:hover {\n    background-color: var(--light-background-color);\n  }\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: var(--secondary-accent-text-color);\n  cursor: pointer;\n  user-select: none;\n}\n\n.checkmark {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  margin-right: 8px;\n  border: 1px solid var(--primary-border-color);\n  border-radius: 2px;\n  position: relative;\n  background-color: var(--white-text-color);\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.company-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.icon {\n  color: var(--white-text-color);\n  stroke-width: 1.5px;\n}\n\n.icon-success {\n  fill: var(--secondary-background-color);\n}\n\n.icon-danger {\n  fill: var(--error-text-color);\n}\n\n.icon-information {\n  fill: var(--highlight-blue-color);\n}\n\n.icon-secondary {\n  color: var(--secondary-accent-text-color);\n}\n\n.icon-navigation {\n  color: var(--primary-text-color);\n  fill: var(--white-text-color);\n}\n\n.icon-navigation-active {\n  fill: var(--primary-text-color);\n  color: var(--white-text-color);\n}\n\n.icon-desktop-navigation-active {\n  fill: var(--tertiary-text-color);\n  color: var(--white-text-color);\n}\n\n.icon-success-toast {\n  fill: var(--secondary-background-color);\n  color: var(--primary-text-color);\n}\n\n.icon-danger-toast {\n  fill: var(--error-text-color);\n  color: var(--primary-text-color);\n}\n\n.required:after {\n  content: \" *\";\n  color: var(--error-text-color);\n}\n\n.error-message {\n  color: var(--error-text-color);\n  font-size: 12px;\n  font-weight: 400;\n}\n\n#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
